import { useToast as useNbToast } from 'native-base';

export const useToast = () => {
  const toast = useNbToast();
  return {
    show: ({ type, message }: { type: 'success' | 'error'; message: string }) =>
      toast.show({ description: message, variant: type === 'success' ? 'top-accent' : 'left-accent' }),
  };
};
